export const interests = [
	{
		title: 'Stay up-to-date with My QIAGEN',
		body: 'Manage your orders, quotes, webinars, instruments and other items of interest.',
		link: {
			text: 'Register now',
			src: '_REGISTRATION_LINK_',
		},
		img: 'S_8995_my-qiagen.jpg',
	},
	{
		title: 'Our Stories',
		body: 'Explore our digital magazine full of customer stories and videos on scientific breakthroughs and healthcare advances.',
		link: {
			text: 'read more',
			src: 'https://www.qiagen.com/customer-stories',
		},
		img: 'S_9576_microbiome_hannah_rose_wardill.jpg',
	},
	{
		title: 'Ordering from QIAGEN',
		body: 'Learn about easy ordering options that offer fast and reliable delivery.',
		link: {
			text: 'discover more',
			src: 'https://www.qiagen.com/knowledge-and-support/ordering-support/',
		},
		img: 'S_5485_ordering.jpg',
	},
];
